import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../API/provider/common-api';
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import { Column, PopUp, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { H2 } from '../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../constans';
import ContentWorkTable, { checkContentManager } from './Table';

export const MARKETS_LIST = ['Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito', 'Bwhite'];

const SHOPS = {
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Megamarket: ['Все', 'megamarket1', 'megamarket2'],
  Avito: ['avito1'],
  "Bwhite": ['bwhite1'],
};

const ContentWorkPage = ({ ...props }) => {
  const user = useSelector((store) => store.user);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: -1000 });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [shop, setShop] = useState(null);
  const [mapMarket, setMapMarket] = useState(SHOPS);
  const { role, name } = useSelector((store) => store.user);
  const [periodPopUp, setPeriodPopUp] = useState(false);
  const [periodStatistic, setPeriodStatistic] = useState({});

  const [contentManager, setContentManager] = useState({ name: 'Не выбран' });

  useEffect(() => {
    let access_providers = user.access_providers;

    let all_providers = { name: 'Все поставщики', id: null };
    let isOwner = user.role === 'owner' || user.role === 'admin';

    const p = allProviders.filter((item) => !item.hide_update);
    if (p.length > 0) {
      let list = [...p, all_providers];
      let list_access = list.filter((p) => access_providers.includes(p.id));
      list_access = list_access.length > 1 ? [all_providers, ...list_access] : list_access;
      setProviders(isOwner ? list : list_access);
      changeProvider(list.length > 1 ? list[0] : { name: 'Все поставщики', id: null });
    } else {
      changeProvider({ name: 'Все поставщики', id: null });
    }
  }, [allProviders, user]);

  useEffect(() => {
    if (MARKETS_LIST.includes(market)) {
      setShop(mapMarket[market][0]);
    }
  }, [market]);

  useEffect(() => {
    let access_shops = user.access_shops;
    let isOwner = user.role === 'owner' || user.role === 'admin';
    let isUser = user.role === 'user'

    let formMarketShops = (market) => {
      let all_markets = 'Все';
      let array = SHOPS[market].filter((shop) => access_shops.includes(shop));
      console.log(array)
      array = (array.length > 1 || isUser) ? [all_markets, ...array] : array;
      return array;
    };
    let map = {};
    Object.keys(SHOPS).forEach((m) => {
      let shops = formMarketShops(m);

      if (shops.length > 0) {
        map[m] = shops;
      }
    });
    map = isOwner ? SHOPS : map;
    let inti_market = Object.keys(map)[0] || null;
    setMapMarket(map);
    setMarket(inti_market || null);

    if (MARKETS_LIST.includes(inti_market)) {
      setShop(mapMarket[market][0]);
    }


  }, [user]);

  const isAdmin = role === 'owner' || role === 'admin';

  return (
    <>
      <Content>
        <Row>
          <WhiteBlock title="Перенос контент на маркетплейсы" style={{ minWidth: '500px', selfAlign: 'normal' }}>
            <Column>
              <Row>
                <Select
                  label="Поставщик"
                  select={provider}
                  valueFn={(p) => p.name}
                  list={providers}
                  width="200px"
                  onSelect={(v) => changeProvider(v)}
                  style={{ marginRight: '15px' }}
                />
                <Select
                  list={Object.keys(mapMarket)}
                  select={market}
                  label="Площадка"
                  onSelect={(v) => setMarket(v)}
                  width={'150px'}
                  style={{ marginRight: '15px' }}
                />
                {(isAdmin || role === 'user') && (
                  <Select
                    list={mapMarket[market] || []}
                    select={shop}
                    label="Магазин"
                    onSelect={(v) => setShop(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                )}

                {((isAdmin) && ['Ozon', 'Wb'].includes(market)) && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    // onClick={() => ProviderCommonApi.excelContentStatistic({ data: { market: market.toLowerCase() } })}
                    onClick={() => setPeriodPopUp(true)}
                    style={{ marginLeft: '15px' }}
                  >
                    Скачать статистику
                  </Button>
                )}


              </Row>

              <Row style={{ marginTop: '20px' }}>
                {user.role !== 'content' && (
                  <SendButton
                    // multiple={true}
                    sendApi={ProviderCommonApi.saveDefault}
                    style={{ marginRight: '15px' }}
                  >
                    Подгрузить основные данные
                  </SendButton>
                )}

                <SendButton
                  // multiple={true}
                  sendApi={ProviderCommonApi.saveContent}
                  style={{ marginRight: '15px' }}
                >
                  Подгрузить контент данные (габариты)
                </SendButton>

                {market === 'Wb' && (
                  <SendButton
                    // multiple={true}
                    sendApi={ProviderCommonApi.saveWbData}
                    style={{ marginRight: '15px' }}
                  >
                    Подгрузить вб данные
                  </SendButton>
                )}

                {market === 'Avito' && (
                  <SendButton
                    // multiple={true}
                    sendApi={ProviderCommonApi.saveAvitoData}
                    style={{ marginRight: '15px' }}
                  >
                    Подгрузить авито данные
                  </SendButton>
                )}
                {market === 'Avito' && (
                  <SendButton
                    // multiple={true}
                    sendApi={ProviderCommonApi.saveAvitoProps}
                    style={{ marginRight: '15px' }}
                  >
                    Подгрузить характеристики
                  </SendButton>
                )}
                {market === 'Ozon' && (
                  <>
                    <SendButton
                      // multiple={true}
                      sendApi={ProviderCommonApi.saveOzonProps}
                      style={{ marginRight: '15px' }}
                    >
                      Подгрузить озон данные
                    </SendButton>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() =>
                        ProviderCommonApi.validateOzonCards({
                          data: {
                            shop,
                            contentManager: user.role !== 'content' ? checkContentManager(contentManager) : user.name,
                          }
                        })
                      }
                    >
                      Провалидировать озон
                    </Button>
                  </>
                )}
                {provider.id === -1 && (
                  <>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => WarehouseCommonApi.sendToContent({})}
                      style={{ marginLeft: '15px' }}
                    >
                      Обновить список товаров
                    </Button>
                  </>
                )}
              </Row>
            </Column>
          </WhiteBlock>
        </Row>
        <ContentWorkTable providerId={provider.id} market={market} shop={shop} setContentManager={setContentManager} />
      </Content>
      {periodPopUp &&
        <PopUp style={{ minWidth: '500px' }} close={() => setPeriodPopUp(false)} clickOutside={true}>
          <H2 style={{ marginBottom: '20px' }}>Улкажите дату начала и конца периода включительно</H2>
          <Row style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Column style={{ marginRight: '15px' }}>
              <InputLabel>Начало периода (Включительно)</InputLabel>
              <Row style={{ width: '230px' }}>
                <DateInput
                  value={periodStatistic.start}
                  onChange={(v) => setPeriodStatistic({ ...periodStatistic, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column >
              <InputLabel>Конец периода (Включительно)</InputLabel>
              <Row style={{ width: '230px' }}>
                <DateInput
                  value={periodStatistic.end}
                  onChange={(v) => setPeriodStatistic({ ...periodStatistic, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
          <Button
            type={TYPE_BUTTONS.WHITE}
            onClick={() => ProviderCommonApi.excelContentStatistic({ data: { market: market.toLowerCase(), period: { ...periodStatistic, end: new Date(moment(periodStatistic.end).add(1, 'day')) } } })}
          // style={{ marginLeft: '15px' }}
          >
            Скачать статистику
          </Button>
        </PopUp>
      }
    </>
  );
};

export default ContentWorkPage;
